import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageBase } from 't4core';
import { CampaignInfo } from '../../../../../projects/t4core/src/public-api';
import { FindCampaignDialog } from '../../dialogs/findCampaignDialog/findCampaignDialog';
import { find } from 'rxjs/operators';


@Component({
  styleUrls: ['./partnerCampaign.css'],
  selector: 'campaing-partnercampaign',
  templateUrl: './partnerCampaign.html',
})

export class PartnerCampaignComponent extends PageBase implements OnInit {

  public activeIsLoading: boolean = false;
  public archivedisLoading: boolean = false;

  public selectedIndex: number = 0; 

  public activeData: CampaignInfo[];

  public activePartnerCampaigns: CampaignInfo[] = [];
  public inheritedPartnerCampaigns: CampaignInfo[] = [];
;
  public historicalPartnerCampaigns: CampaignInfo[] =[];
  public currentTime: Date = new Date();

  public constructor(el: ElementRef, private router: Router) {
    super(el, "PartnerCampaign");
  }

  public async ngOnInit() {

    this.activeIsLoading = true;
    this.activeData = await this.Api.get<CampaignInfo[]>("/Campaign/GetActivePartnerCampaigns");
    this.sortPartnerCampaigns();
    this.activeIsLoading = false;

    this.archivedisLoading = true;
    this.historicalPartnerCampaigns = await this.Api.get<CampaignInfo[]>("/Campaign/GetArchivedPartnerCampaigns");
    this.archivedisLoading = false;

  }

  public async createCampaign() {
    var ret = await this.UI.openDialog<boolean>("T4.Campaings.CreatePartnerCampaingDialog", { width: '1200px', data: null });
    if (ret) {
      const updatedCampaigns = await this.Api.get<CampaignInfo[]>("/Campaign/GetActivePartnerCampaigns");
      this.activePartnerCampaigns = [...updatedCampaigns];
    }
  }

  public async editCampaign(info: CampaignInfo) {
    var ret = await this.UI.openDialog<boolean>("T4.Campaings.CreatePartnerCampaingDialog", { width: '1200px', data: info });
    if (ret) {
      const updatedCampaigns = await this.Api.get<CampaignInfo[]>("/Campaign/GetActivePartnerCampaigns");
      this.activePartnerCampaigns = [...updatedCampaigns];
    }
  }

  public findCampaign() {
    this.Dialog.open(FindCampaignDialog, {
    });
  }

  sortPartnerCampaigns() {
    this.activeData.forEach(x => {
      if (x.CanEdit) this.activePartnerCampaigns.push(x)
      else this.inheritedPartnerCampaigns.push(x)
    });
  }
}

